(function () {
  var BACKEND_URL = 'https://cavern-app-backend.onrender.com';
  var COLLECTION_TOKEN_KEY = 'cavernCollectionSessionToken';
  var REWARDS_TOKEN_KEY = 'vernAuthToken';

  function readStorage(key) {
    try {
      return window.localStorage.getItem(key) || '';
    } catch (_) {
      return '';
    }
  }

  function removeStorage(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (_) {
      // Some browsers block storage in private modes.
    }
  }

  function migrateCollectionToken(token) {
    if (!token || !window.fetch) return;

    window.fetch(BACKEND_URL + '/api/auth/session-cookie', {
      method: 'POST',
      mode: 'cors',
      credentials: 'include',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      body: '{}',
    }).catch(function () {
      // Cleanup still wins if the old token is expired or the request is blocked.
    });
  }

  var oldCollectionToken = readStorage(COLLECTION_TOKEN_KEY);
  removeStorage(COLLECTION_TOKEN_KEY);
  removeStorage(REWARDS_TOKEN_KEY);
  migrateCollectionToken(oldCollectionToken);
})();
